// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608270706/js/" + chunkId + "." + {"44":"8866d3ea","225":"6a8df6ab","481":"6a5dedd3","486":"ffd8b5a7","770":"9fd79683"}[chunkId] + ".0.7653052494539238.chunk.js";
};